export const OUTCOME_NODE_TYPE = 'learning-outcome'
